if (!customElements.get('bh3d-review-rating')) {
    const reviewSummaryCache = new Map();
    const refreshAfter = 5 * 60 * 1000;
    const getReviewSummary = (companyId) => {
      const cached = reviewSummaryCache.get(companyId);
      if (cached && Date.now() < cached.expires) return cached.promise;
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 8000);
      const url = new URL('https://fast.a.klaviyo.com/reviews/api/client_reviews/all/');
      url.search = new URLSearchParams({company_id: companyId, limit: '1', type: 'reviews'}).toString();
      const promise = fetch(url, {signal: controller.signal, credentials: 'omit'})
        .then(response => { if (!response.ok) throw new Error('Reviews unavailable'); return response.json(); })
        .then(({summary}) => {
          const rating = Number(summary?.star_rating);
          const count = Number(summary?.review_count);
          if (!Number.isFinite(rating) || rating < 1 || rating > 5 || !Number.isSafeInteger(count) || count < 1) throw new Error('Invalid review summary');
          return {rating, count};
        })
        .catch(() => null)
        .finally(() => clearTimeout(timeout));
      reviewSummaryCache.set(companyId, {promise, expires: Date.now() + refreshAfter});
      return promise;
    };
    class BH3DReviewRating extends HTMLElement {
      connectedCallback() {
        this.drawer = this.closest('cart-drawer');
        this.refresh = this.refresh.bind(this);
        this.refresh();
        if (this.drawer) {
          this.observer = new MutationObserver(this.refresh);
          this.observer.observe(this.drawer, {attributes: true, attributeFilter: ['aria-hidden']});
        }
        this.timer = setInterval(this.refresh, refreshAfter);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        clearInterval(this.timer);
      }
      async refresh() {
        if (document.visibilityState === 'hidden' || this.drawer?.getAttribute('aria-hidden') === 'true') return;
        const companyId = this.dataset.companyId;
        if (!companyId) return;
        const summary = await getReviewSummary(companyId);
        if (!this.isConnected) return;
        const label = this.querySelector('.bh3d-review-trust__text');
        const link = this.querySelector('a');
        if (!label || !link) return;
        if (!summary) {
          label.textContent = 'Read customer reviews →';
          link.setAttribute('aria-label', 'Read customer reviews');
          return;
        }
        const rating = summary.rating.toFixed(1);
        const count = new Intl.NumberFormat('en-GB').format(summary.count);
        label.textContent = `${rating} / 5 · ${count} product reviews →`;
        link.setAttribute('aria-label', `Rated ${rating} out of 5 from ${count} product reviews. Read customer reviews.`);
      }
    }
    customElements.define('bh3d-review-rating', BH3DReviewRating);
  }
